<div class="mnabrDialog alertonly">
    <h1 class="mattitle">{{title}} <mat-icon class="dialogicon red" style="background-color: #ff0000 !important;" matTooltip="{{'lang_close' | language}}" (click)="close()">close</mat-icon></h1>
    <div class="matbody" style="word-break: break-all;">
        <p>{{message}}</p>
    </div>
</div>